import { createSelector } from '@reduxjs/toolkit';
import { ProjectParameters } from 'ducks/types/store-types';
import { RootState } from 'store';

const jobParametersSlice = (state: RootState) => state.job_parameters;

export const selectJobParameters = createSelector([jobParametersSlice], (state): ProjectParameters => state);

export const selectJobInputParameters = createSelector(
  [jobParametersSlice],
  (state): ProjectParameters => state.filter((row) => row.parameter_direction_id === 1),
);

export const selectJobOutputParameters = createSelector(
  [jobParametersSlice],
  (state): ProjectParameters => state.filter((row) => row.parameter_direction_id === 2),
);
